import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { sanitize } from '@ideals/utils/sanitize';

@Pipe({
  name: 'sanitize',
})
export class SanitizePipe implements PipeTransform {
  readonly #sanitizer = inject(DomSanitizer);

  transform(text: string): SafeHtml {
    return this.#sanitizer.bypassSecurityTrustHtml(sanitize(text));
  }
}
